import React, { useLayoutEffect, useState } from 'react';
import { Button, Tooltip, message } from 'antd';
import {
  CloseOutlined,
  EditOutlined,
  DownloadOutlined,
    EyeOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from "react-router-dom";
// import ImageEditorModal from '../modals/ImageEditorModal';
import KonvaImageEditorModal from '../modals/KonvaEditorModal';
import {getImageSizeFromBlob, getAspect, isAspectInRange, aspectToRatioString} from "../../utils/ImageUtils/imageRatio";

const PostPhotoEditor = ({ index, image, onImageChange, aspectRange }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isModalOpen, setIsModalOpen] = useState(index === Number(searchParams.get('image')));
  const [showImageEditor, setShowImageEditor] = useState(false);
  const range = aspectRange ?? { min: 0.5, max: 2.0 };

    const url = typeof image === 'string' ? image : image?.imageUrl || '';

    const handleModalSetVisible = (state = false) => {
    setIsModalOpen(state);
    if (state) {
      setSearchParams((prev) => {
        prev.set("image", index);
        return prev;
      });
    } else {
      setSearchParams((prev) => {
        prev.delete("image");
        return prev;
      });
    }
  };

  const handleOpenImageEditor = (e) => {
    e.stopPropagation();
    setShowImageEditor(true);
    handleModalSetVisible(false);
  };

  const handleSaveEditedImage = async (editedFile) => {

      const { width, height } = await getImageSizeFromBlob(editedFile);
      const aspect = getAspect(width, height);

      if (!isAspectInRange(aspect, range)) {
          message.error(t("postPage.message.aspectOutRange", {
              aspect: aspectToRatioString(aspect),
              min: range.minLabel || aspectToRatioString(range.min),
              max: range.maxLabel || aspectToRatioString(range.max),
          }))
          return;
      }

      const blobUrl = URL.createObjectURL(editedFile);

      onImageChange(blobUrl);
      message.success(t('imageEditor.messages.saveSuccess'));
      setShowImageEditor(false);
  };

  const handleDownloadImage = (e) => {
      e.stopPropagation();
      const link = document.createElement('a');
      link.href = url;
      link.download = (url.split('/').pop() || `image-${index}.jpg`).split('?')[0];
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  };

  useLayoutEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isModalOpen]);

  if (!url) return null;

  return (
    <>
      <div className="relative group">
        <img
          src={url}
          alt="Preview"
          className="max-w-full w-full h-auto rounded-lg shadow-md cursor-pointer transition-all duration-200"
          onClick={() => handleModalSetVisible(true)}
        />

        <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-200 rounded-lg flex items-center justify-center gap-3">
          <Tooltip title={t('postPage.imageEditor.viewImage')}>
            <Button
              type="default"
              shape="circle"
              size="large"
              icon={<EyeOutlined />}
              onClick={() => handleModalSetVisible(true)}
              className="bg-white/90 hover:bg-white"
            />
          </Tooltip>
          <Tooltip title={t('postPage.imageEditor.editImage')}>
            <Button
              type="primary"
              shape="circle"
              size="large"
              icon={<EditOutlined />}
              onClick={handleOpenImageEditor}
            />
          </Tooltip>
        </div>
      </div>

      <div
        className={`w-full h-full fixed top-0 left-0 flex justify-center items-center flex-col bg-black/75 backdrop-blur-sm ${isModalOpen ? 'opacity-100 z-[1000] overflow-auto' : 'opacity-0 pointer-events-none'
          } transition-all duration-300 ease-in-out`}
        onClick={() => handleModalSetVisible(false)}
      >
        <div className="py-5 flex justify-center items-center flex-col w-full">
          <div
            className="relative w-full max-w-xl px-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="fixed top-2 right-2 z-50 flex gap-2">
              <Tooltip title={t('postPage.imageEditor.downloadImage')}>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={handleDownloadImage}
                  className={`shadow-lg ${isModalOpen ? 'opacity-100' : 'opacity-0'} transition-all duration-300 ease-in-out`}
                >
                  {t('postPage.imageEditor.download')}
                </Button>
              </Tooltip>
              <Tooltip title={t('postPage.imageEditor.editImage')}>
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={handleOpenImageEditor}
                  className={`shadow-lg ${isModalOpen ? 'opacity-100' : 'opacity-0'} transition-all duration-300 ease-in-out`}
                >
                  {t('postPage.imageEditor.edit')}
                </Button>
              </Tooltip>
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={() => handleModalSetVisible(false)}
                className={`text-white/75 hover:text-white text-xl ${isModalOpen ? 'opacity-100' : 'opacity-0'} transition-all duration-300 ease-in-out`}
                size="large"
              />
            </div>

            <img
              src={url}
              alt="Preview"
              className={`w-full h-auto rounded-lg shadow-md my-5 ${isModalOpen ? 'scale-100' : 'scale-0'
                } transition-all duration-300 ease-in-out`}
            />
          </div>
        </div>
      </div>

      {/* <ImageEditorModal
        visible={showImageEditor}
        imageUrl={image?.imageUrl}
        onSave={handleSaveEditedImage}
        onCancel={() => setShowImageEditor(false)}
      /> */}

      <KonvaImageEditorModal
        visible={showImageEditor}
        imageUrl={url}
        onSave={handleSaveEditedImage}
        onCancel={() => setShowImageEditor(false)}
      />
    </>
  );
};

export default PostPhotoEditor;